import { apiClient } from '~/api/client';
import cookie from 'js-cookie';
export * as Company from './company';

export const show = () => apiClient.get('/current_user');
export const signout = async () => {
  const cookies = JSON.parse(cookie.get('auth_cookie') as string);
  // Pass headers to make sure that Devise Token Auth get correct data
  const headers = {
    uid: cookies.uid,
    client: cookies.client,
    'access-token': cookies['access-token'],
  };
  apiClient.get('/signout', { headers });
};
